import { createIllustration } from '@yandex-data-ui/common';
var store = {
  light: {
    'no-results': function noResults() {
      return import('../../assets/images/light/no-results');
    }
  },
  dark: {
    'no-results': function noResults() {
      return import('../../assets/images/dark/no-results');
    }
  }
};
export var Illustration = createIllustration([store]);
// #sourceMappingURL=Illustration.js.map